export default "/assets/dairy-free.svg";